class RecommendedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.url = this.getAttribute("data-url");
    this.init();
  }

  init() {
    this.domElements();
    this.getProducts();
  }

  domElements() {
    this.contentWrapper = this.querySelector(".recommended-products__content");
    this.footer = this.querySelector(".recommended-products__footer");
    this.header = this.querySelector(".recommended-products__header");
  }

  handleRender(html) {
    const newElement = html.querySelector(".recommended-products__content");
    this.contentWrapper.innerHTML = newElement.innerHTML;
  }

  handleAddLoadingClass() {
    if (this.footer)
      this.footer.classList.add("recommended-products__footer--loading");
    if (this.header)
      this.header.classList.add("recommended-products__header--loading");
  }

  handleRemoveLoadingClass() {
    if (this.footer)
      this.footer.classList.remove("recommended-products__footer--loading");
    if (this.header)
      this.header.classList.remove("recommended-products__header--loading");
  }

  async getProducts() {
    try {
      this.handleAddLoadingClass();
      const response = await fetch(this.url);
      const html = await response.text();
      if (!response.ok) throw new Error(html);
      const htmlDoc = new DOMParser().parseFromString(html, "text/html");
      this.handleRender(htmlDoc);
    } catch (error) {
      console.error("Error recommended fetching products:", error);
    } finally {
      this.handleRemoveLoadingClass();
    }
  }

  disconnectedCallback() {}
}

customElements.define("recommended-products", RecommendedProducts);
